import SelectionModel from '@mediaplatform/sportal365-odds-utils/types/models/selection.model';
import { invertColor, isMobileUserAgent } from '@sportal365/smp-widget-utils';
import { FC, useMemo } from 'react';
import { DESKTOP, MOBILE } from '../../../../constants/deviceTypes';
import { GenericSize } from '../../../../constants/generic';
import { CurrencyPosition, INormalizedFootballTeam } from '../../../../types';
import { SMPText, styled } from '../../../index';

interface TeamStakeProps {
  contrastFallbackColor: string;
  currency: string;
  handleOddCoefficientClick: (link: string) => void;
  selection: SelectionModel;
  size?: GenericSize;
  team: INormalizedFootballTeam;
  wins: string;
  currencyPosition?: CurrencyPosition;
}

export const TeamStake: FC<TeamStakeProps> = ({
  contrastFallbackColor,
  currency,
  handleOddCoefficientClick,
  selection,
  size,
  team,
  wins,
  currencyPosition,
}) => {
  const url = useMemo(() => {
    if (selection.odds === null) {
      return undefined;
    }

    return (
      (selection.urls?.find(({ appType }) => appType === (isMobileUserAgent() ? MOBILE : DESKTOP)) ?? selection.urls?.[0])?.url ?? undefined
    );
  }, [selection.odds, selection.urls]);

  const value = currencyPosition === 'prefix' ? `${currency} ${wins}` : `${wins} ${currency}`;

  return (
    <TeamButton
      href={url}
      target='_blank'
      onClick={() => url && handleOddCoefficientClick(url)}
      css={{ backgroundColor: team.shirtColor ?? '$oddsSelectionBackgroundColor' }}
    >
      <SMPText
        display='flex'
        size={size !== GenericSize.DEFAULT ? '4' : '2_5'}
        variant='contrast'
        css={{
          alignItems: 'center',
          gap: '$1',
          height: '100%',
          color: team.shirtColor ? invertColor(team.shirtColor, true) : contrastFallbackColor,
        }}
      >
        {team.threeLetterCode}
        <strong style={{ textAlign: 'end' }}>{value}</strong>
      </SMPText>
    </TeamButton>
  );
};

const TeamButton = styled.withConfig({ componentId: 'StakesDisplayFixed', displayName: 'TeamButton' })('a', {
  border: '1px solid $teamStakesBorderColor',
  borderRadius: '$1',
  width: '177px',
  py: '$2',
  px: '$2_5',
  textDecoration: 'none',
  cursor: 'pointer',

  [`${SMPText}`]: {
    justifyContent: 'space-between',
    width: '100%',
  },
});

export default TeamStake;
